import styled from '@emotion/styled';

const LinksSection = styled.div`
//position: absolute;
//bottom: 0;
margin-top: 2.25rem;
`;

export default LinksSection;
